import React, { ChangeEvent, FC } from 'react'
import { Control, Controller, FieldErrors } from 'react-hook-form'
import { Box, BoxProps } from 'transfix-ui/core'
import { TimeInput, TIME_INPUT_FORMAT } from 'transfix-ui'

interface IControlledTimeInput {
  control?: Control
  /**
   * @default 'issue-due-time'
   */
  dataTest?: string
  errors?: FieldErrors
  /**
   * @default 'Due Time'
   */
  label?: string
  /**
   * @default 'dueTime'
   */
  name?: string
  /**
   * @default 'Due Time'
   */
  placeholder?: string
  value?: string | null
  /**
   * @default { ml: 1 }
   */
  BoxProps?: BoxProps
}

const ControlledTimeInput: FC<IControlledTimeInput> = ({
  control,
  dataTest = 'issue-due-time',
  errors,
  label = 'Due Time',
  name = 'dueTime',
  placeholder = 'Due Time',
  value,
  BoxProps = {
    ml: 1,
  },
}) => (
  <Box {...BoxProps}>
    <Controller
      name='dueTime'
      control={control}
      defaultValue={value}
      render={({ onChange, value }) => {
        const changeTimeHandler = (ev: ChangeEvent<HTMLInputElement>) => onChange(ev.target.value)

        return (
          <TimeInput
            label={label}
            large
            value={value}
            onChange={changeTimeHandler}
            timeFormat={TIME_INPUT_FORMAT.MILITARY}
            invalid={errors && errors[name]}
            validationMessage={errors && errors[name]?.message}
            dataTest={dataTest}
            placeholder={placeholder}
          />
        )
      }}
    />
  </Box>
)

export default ControlledTimeInput
